<template>
  <div>
    <data-select
      :size="size"
      :title="title"
      :defaultParams="defaultParams"
      :placeholder="placeholder"
      :fieldList="fieldList"
      :paramList="paramList"
      :width="1000"
      :showMenu="true"
      :menuWidth="200"
      listApi="biz.goods.sku.info.list"
      valuePropName="guid"
    >
      <template slot="menu" slot-scope="scope">
        <goods-classify-list
          @change="handleClassifyChange"
          :value="classifyGuid"
        />
      </template>
      <template slot="row-info" slot-scope="scope">
        <goods-sku-info :skuInfo="scope.row" :showCostPrice="showCostPrice">
          <template slot="info-append" slot-scope="scope">
            <slot name="info-append" :info="scope.info" />
          </template>
        </goods-sku-info>
      </template>
    </data-select>
  </div>
</template>

<script>
import dataSelect from '../dataSelect.vue';
import goodsClassifyList from './goodsClassifyList.vue';
import goodsSkuInfo from './goodsSkuInfo.vue';

export default {
  components: {
    dataSelect,
    goodsSkuInfo,
    goodsClassifyList,
  },
  props: {
    size: {
      type: String,
    },
    title: {
      type: String,
      default: "请选择",
    },
    showCostPrice: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "选择商品",
    },
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    defaultParams() {
      return Object.assign({
        optStatus: 1,
        classifyGuid: this.classifyGuid,
      }, this.params || {}, this.queryModel || {})
    }
  },
  data() {
    return {
      queryModel: {},
      classifyGuid: "",
      fieldList: [
        {
          label: '商品信息',
          minWidth: '320',
          slot: "info",
        },
      ],
      paramList: [
        {
          label: '查询关键词',
          field: ['queryValue'],
          styleValue: "width: 300px"
        }
      ]
    };
  },
  methods: {
    handleClassifyChange(guid) {
      this.classifyGuid = guid;
    },
  },
}
</script>